import * as React from 'react';
import { connect } from 'react-redux';
import { IPerformance, IZone } from '../../custom/classes/production';
import { IPackageListingAppState } from '../../redux-state';
import { removeItemFromCart, removeSelectedZone } from '../../redux-state/actions/package-listing.actions';
import { IPackageListingAppText } from '../../custom/classes/package-listing-text';
import { flatMap } from 'lodash';
import { getCartItemDetails } from '../../helpers/cart-helpers';
import { IPerformanceErrorMessage } from '../../../package-listing/classes/package-listing';
import { UnseatedFlexCartItemsProps } from './unseated-flex-cart-Items';
import UnseatedFlexCartItemView from 'unseated-flex-cart-item.view';

interface IUnseatedFlexCartItemExternalProps {
    itemId: number;
    selectedZoneId: number;
    
    hideSeatMap: boolean;
    showSeatMapOnly?: boolean;
    showTitleAndRemoveButton?: boolean;
    showZoneDropdown?: boolean;
}

interface StateToProps {
    text: IPackageListingAppText;
    itemProcessErrorMessage: string;
    selectedZone: IZone;
    itemIdToRemove: number;
    itemTitle: string;
    itemSeason: string;
    itemFacility: string;
    itemDateString: string;
    itemTimeString: string;
    isFixedPackage: boolean;
    showRemoveButton: boolean;
}

interface DispatchToProps {
    removeItem: (itemId: number) => void;
    removeZone: (itemId: number) => void;
}

export type UnseatedFlexCartItemProps = IUnseatedFlexCartItemExternalProps & StateToProps & DispatchToProps;

export class UnseatedFlexCartItemBase extends React.Component<UnseatedFlexCartItemProps, any> {
    constructor(props: UnseatedFlexCartItemProps) {
        super(props);
    }

    render() {
        return <UnseatedFlexCartItemView {...this.props} {...this.state} />;
    }
}

function mapStateToProps(state: IPackageListingAppState, ownProps: IUnseatedFlexCartItemExternalProps): StateToProps {
    var perfMessage: Array<IPerformanceErrorMessage> = [];
    if (state.packageListing.errorMessages != undefined)
        perfMessage = state.packageListing.errorMessages.filter(err => err.performanceId === ownProps.itemId);
    var performancePricing = state.packageListing.performancePricingList
        .get(ownProps.itemId);

    var itemDetails = getCartItemDetails(state, ownProps.itemId);

    if (!performancePricing) {
        performancePricing = state.packageListing.performancePricingList.get(itemDetails.itemIdToRemove);
    }

    return {
        text: state.packageListingText,
        isFixedPackage: state.packageListingSettings.isFixed,
        itemProcessErrorMessage: perfMessage.length > 0 ? perfMessage[0].errorMessage : "",
        selectedZone: performancePricing ? performancePricing.zones
            .filter(z => z.zone.id == ownProps.selectedZoneId)[0]
            : null,
        itemIdToRemove: itemDetails.itemIdToRemove,
        itemDateString: itemDetails.itemDate,
        itemTimeString: itemDetails.itemTime,
        itemFacility: itemDetails.facility.facilityDescription,
        itemTitle: itemDetails.itemTitle,
        itemSeason: itemDetails.itemSeason,
        showRemoveButton: state.packageListing.packages.length !== 1
    }
}

function mapDispatchToProps(dispatch, ownProps: UnseatedFlexCartItemProps): DispatchToProps {
    return {
        removeItem: (itemId: number) => {
            dispatch(removeItemFromCart(itemId));

        },
        removeZone: (itemId: number) => {
            dispatch(removeSelectedZone(itemId));

        }
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(UnseatedFlexCartItemBase);